import React, { useContext, useEffect, useState } from 'react';
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'
import { Grid, Typography } from '@material-ui/core';
import { FieldError } from '../../../../common';
import { AddressForm } from '../common/AddressForm';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    invalidField: {        
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}));

export const InvoiceAddressForm = (props) => {
    const classes = useStyles();

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        formSuffixName, 
        suffixIndex 
    } = props;

    return (
        <Grid container spacing={3}>
            <Grid item xl={12} md={12} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.shipName`}
                    label="Ship name *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.shipName`} errors={state.errors} />
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
                <AddressForm 
                    formSuffixName={`${formSuffixName}.address`} 
                    suffixIndex={suffixIndex} 
                    disabled={props.disabled} />
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
                <Typography variant="subtitle1">
                    Contact
                </Typography>
            </Grid>
            <Grid item xl={6} md={6} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.email`}
                    label="Email *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.email`} errors={state.errors} />
            </Grid>
            <Grid item xl={6} md={6} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.phoneFax`}
                    label="Tel/Fax *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.phoneFax`} errors={state.errors} />
            </Grid>
            {/* <Divider className={classes.field}/>
            <Grid item xl={6} md={12} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.vatNumber`}
                    label="VAT Number *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.vatNumber`} errors={state.errors} />
            </Grid>
            <Grid item xl={6} md={12} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.taxNumber`}
                    label="TAX Number *"
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.taxNumber`} errors={state.errors} />
            </Grid> */}
        </Grid>
    );
}